import styled from '@emotion/styled';
import { Text7 } from './Text7';

export const Text8 = styled(Text7)`
  font-weight: 500;
`;
